import {BOT_CONV_MESSAGE_TYPE} from '../../../../consts/common-consts';
import ChatDate from "../../../chat-date";
import { safeString } from '../../../../../../../helpers/utils/text-util';
import { bubbleClass } from '../bubble-style';

export default function TextMessage({senderType, message, date}) {
  const isBot = senderType === BOT_CONV_MESSAGE_TYPE;

  return (
    <div className={bubbleClass(isBot)}>
      <p className='whitespace-pre-wrap break-words'>{safeString(message)}</p>
      <ChatDate date={date} isBot={isBot} />
    </div>
  );
}
